import { Box, Typography } from '@locus-taxy/encore-mui';
import { useTranslation } from '@locus-taxy/encore-i18n-toolkit';
import { GeneralSection } from './UserDetails/GeneralSection';
import { LocaleSettingsSection } from './UserDetails/LocaleSettingsSection';
import { useUserProfile } from './UserDetails/useUserProfile';
import { getTestId } from '@locus-taxy/encore-utils';
import { TestIdAction } from '../utils/testIdUtils';

export default function UserDetails() {
  const { t } = useTranslation();
  const {
    fullName,
    emailAddress,
    photo,
    configuredTimezone,
    configuredLocale,
    timezoneOptions,
    localeOptions,
    handleUpdateTimezone,
    handleUpdateLocale,
    handleUpdatePhoto,
    isUpdating,
    canUpdate,
    clientId,
  } = useUserProfile();

  return (
    <Box
      sx={{ p: 3, backgroundColor: 'grey.200', height: '100%' }}
      data-testid={getTestId({
        action: TestIdAction.VIEW,
        object: 'account-page-container',
        page: 'account',
      })}
    >
      <Typography variant="h5" sx={{ mb: 2 }}>
        {t('userDetails.accountSettings')}
      </Typography>

      <GeneralSection
        fullName={fullName}
        emailAddress={emailAddress}
        photo={photo}
        onPhotoUpdate={handleUpdatePhoto}
        isUpdating={isUpdating}
        canUpdate={canUpdate}
        clientId={clientId}
      />

      <LocaleSettingsSection
        timezone={configuredTimezone}
        timezoneOptions={timezoneOptions}
        locale={configuredLocale}
        localeOptions={localeOptions}
        onTimezoneChange={handleUpdateTimezone}
        onLocaleChange={handleUpdateLocale}
        isUpdating={isUpdating}
        canUpdate={canUpdate}
      />
    </Box>
  );
}
